import { currencyConstants } from './currencyConstants';

export const getCurrencySymbol = (currencyENUM: string | null | undefined): string | null => {
    return currencyENUM ? currencyConstants.symbols[currencyENUM] : null;
};
